<app-doc-viewer title="Dynamic Component" subtitle="Common">
  <app-example-viewer codeFolder="common/dynamic-component">
    <igo-dynamic-outlet [component]="component" [inputs]="inputs" />

    <button mat-flat-button color="primary" (click)="toggleComponent()">
      Toggle Component
    </button>
  </app-example-viewer>
</app-doc-viewer>
